<form class="password-form">
  <p-fluid class="mb-3">
    <p-floatlabel variant="on" styleClass="text-input">
      <p-password
        [formControl]="changePasswordForm.controls.password"
        [toggleMask]="true"
        [promptLabel]="'Geef wachtwoord in' | translate"
        [weakLabel]="'Kies een sterker wachtwoord' | translate"
        [mediumLabel]="'Wachtwoord kan beter' | translate"
        [strongLabel]="'Sterk wachtwoord' | translate"
      />
      <label for="on_label">
        {{ 'Wachtwoord' | translate }}
        <span class="required-indicator">*</span>
      </label>
    </p-floatlabel>
  </p-fluid>

  <div class="password-requirements mb-3">
    <p class="requirements-title">Wachtwoordvereisten:</p>
    <ul class="requirements-list">
      <li [class.valid]="hasMinLength()" [class.invalid]="!hasMinLength() && changePasswordForm.controls.password.touched">
        <i [class]="hasMinLength() ? 'pi pi-check' : 'pi pi-times'"></i>
        {{ 'Minstens 8 tekens' | translate }}
      </li>
      <li [class.valid]="hasUpperCase()" [class.invalid]="!hasUpperCase() && changePasswordForm.controls.password.touched">
        <i [class]="hasUpperCase() ? 'pi pi-check' : 'pi pi-times'"></i>
        {{ 'Minstens één hoofdletter' | translate }}
      </li>
      <li [class.valid]="hasNumber()" [class.invalid]="!hasNumber() && changePasswordForm.controls.password.touched">
        <i [class]="hasNumber() ? 'pi pi-check' : 'pi pi-times'"></i>
        {{ 'Minstens één cijfer' | translate }}
      </li>
      <li [class.valid]="hasSpecialChar()" [class.invalid]="!hasSpecialChar() && changePasswordForm.controls.password.touched">
        <i [class]="hasSpecialChar() ? 'pi pi-check' : 'pi pi-times'"></i>
        {{ 'Minstens één speciaal teken' | translate }}
      </li>
    </ul>
  </div>

  <p-fluid class="mb-5">
    <p-floatlabel variant="on" styleClass="text-input">
      <p-password [formControl]="changePasswordForm.controls.passwordRepeat" [toggleMask]="true" [feedback]="false" />

      <label for="on_label">
        {{ 'Herhaal wachtwoord' | translate }}
        <span class="required-indicator">*</span>
      </label>
    </p-floatlabel>
  </p-fluid>
</form>
